import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import PrayerTimes from "../user-settings/prayer-times";
import BackButton from "../../../components/buttons/BackButton";
import MethodCards from "./method-cards";

const PrayerTimeAthan = () => {
  const { t } = useTranslation();
  const [inUse, setInUse] = useState("");

  return (
    <>
      <section className="bg-gradient-to-b from-slate-50 to-gray-50">
        <div className="max-w-4xl p-6 space-y-6">
          <h1 className="text-2xl text-start font-semibold text-slate-800 flex items-center gap-2">
            <BackButton /> {t("athanCalculationTitle")}
          </h1>
          <MethodCards
            base="/user-dashboard/prayer-times/athan"
            inUse={inUse}
            calculateTitle={t("automaticCalculationMethod")}
            calculateText="Times worked out from your masjid's location."
            importText="Upload your own athan timetable (CSV or Excel)."
          />
        </div>
      </section>

      <PrayerTimes mode="athan" onLoaded={(data) => setInUse(data.custom ? "custom" : "method")} />
    </>
  );
};

export default PrayerTimeAthan;
